module.exports = __webpack_public_path__ + "static/media/red-number-2.66b985ea.png";